export default __webpack_public_path__ + "static/media/space_part6.870f7c66.png";